<app-page headerMode="none"
          headerLogoLink=""
          [showHeader]="false"
          [showFooter]="false"
          [footerShowNavi]="false">
  <div class="v2-max-w-120 margin-auto v2-min-h-50 body-2 color-green-grey-1 v2-padding-5-b"
       [ngClass]="sm ? 'v2-padding-2-h' : 'v2-padding-5-h'">
    <div class="h1 text-center">Secondary Market Trading Agreement</div>

    <div class=WordSection1>

      <p class=MsoBodyText
         style='margin-top:.55pt'><strong>&nbsp;</strong></p>

      <p class=MsoNormal
         style='margin-top:.05pt;margin-right:5.85pt;margin-bottom:
0cm;margin-left:5.95pt;margin-bottom:.0001pt;text-align:justify'><strong><span>THIS SECONDARY MARKET
            TRADING AGREEMENT </span></strong><span>(this &quot;<strong>Agreement</strong>&quot;) governs all
          transactions and is a binding contract among the <strong>Owner/Seller</strong>, the true
          and beneficial owner of certain units or shares (“<strong>Shares</strong>”) of a security
          (the “<strong>Security</strong>”), or the <strong>Buyer/Bidder </strong>(each individually, as the
          case may be, the “<strong>User</strong>”), <strong>Andes Capital Group, LLC</strong>, a registered
          broker-dealer and member of the Financial Industry Regulatory Authority, Inc.
          (“<strong>FINRA</strong>”) and the Securities Industry Protection Corporation (“<strong>SIPC</strong>”)
          (“<strong>Andes Capital Group</strong>” or “<strong>Company</strong>”). This Agreement governs the
          terms under which the User is granted the right to bid for, purchase, offer for
          sale and/or sell Shares of the Security through the <strong>North Capital Private
            Securities Corporation Alternative Trading System </strong>(the &quot;<strong>Platform</strong>&quot;). All
          User activity on the Platform is
          governed by this Agreement and other
          documents included by reference.</span></p>

      <p class=MsoBodyText
         style='margin-top:1.25pt'>&nbsp;</p>

      <p class=MsoNormal
         style='margin-top:.05pt;margin-right:6.0pt;margin-bottom:
0cm;margin-left:5.95pt;margin-bottom:.0001pt;text-align:justify'><strong><span>NOTICE: Please read
            all referenced Agreements,
            Disclosures, Policies, and Terms of Service. These terms contain important information, including a binding
            arbitration agreement that impacts your rights when disputes are resolved. If any of these terms are
            unacceptable to
            the User, then please do not visit, access or use the Platform.</span></strong></p>

      <p class=MsoBodyText
         style='margin-top:10.1pt;margin-right:5.9pt;margin-bottom:
0cm;margin-left:5.95pt;margin-bottom:.0001pt;text-align:justify'>The User, when
        acting as a seller, is the owner of Shares of the Security and upon acceptance
        of this Agreement, shall grant Company the exclusive right to offer for sale on
        the Platform the User's Shares in the Security for the period of time chosen by Seller, or good ‘til canceled if
        no period of time is chosen by Seller (“<strong>Term</strong>”), at the<span>
        </span>Ask Price
        for the number of shares specified by the User.</p>

      <p class=MsoBodyText
         style='margin-top:.05pt'>&nbsp;</p>

      <p class=MsoBodyText
         style='margin-top:0cm;margin-right:5.95pt;margin-bottom:
0cm;margin-left:5.95pt;margin-bottom:.0001pt;text-align:justify'>By accepting
        the terms of this Agreement, the User offering the Security shall be obligated
        to sell Shares of the Security if a transaction is executed at the Ask Price
        set by the User during the term of the order, and the User bidding on
        the Security shall be obligated
        to buy Shares of the Security if a transaction is executed at the Bid Price<span>
        </span>set by the User during the term of the
        order.</p>

      <p class=MsoListParagraph
         align=left
         style='margin-top:10.3pt;margin-right:
0cm;margin-bottom:0cm;margin-left:41.95pt;margin-bottom:.0001pt;text-align:
left;text-indent:-17.95pt'><strong><span>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span></strong><strong><span>Eligibility of User to Trade on <span>Platform</span></span></strong>
      </p>

      <p class=MsoListParagraph
         style='margin-top:10.2pt;margin-right:5.95pt;
margin-bottom:0cm;margin-left:77.25pt;margin-bottom:.0001pt'><strong><span>a.<span
                  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span></strong><strong><span>Account Approval - </span></strong><span>Each prospective User is
          required to register on the
          Platform by completing the investor registration process, and be approved, in
          order to have trading access to the Platform. Each User must complete the
          investor registration process, which will require the User to provide certain
          personal information, including but in no way limited to, such as: legal name,
          address, phone number, date of birth,
          social security number, residency information, valid ID, accreditation
          information (as required), financial status, proof of funds, proof of banking
          relationship, employment information and financial experience. The
          User acknowledges that the Company is
          the final decision maker of when or if a User is approved and owes no
          explanation to the applying User if the
          User’s application to the Platform is denied.</span></p>

      <p class=MsoBodyText
         style='margin-top:1.1pt'>&nbsp;</p>

      <p class=MsoListParagraph><strong><span>b.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span></strong><strong><span>Identity Verification - </span></strong><span>All Users are
          subject to Anti-Money Laundering (“AML”)
          and Know Your Client (“KYC”) rules and regulations of FINRA and other
          applicable regulatory agencies. The User authorizes the Company to make any
          inquiries necessary to verify the identity of the User, protect against fraud
          or other financial crimes and/or comply with the legal obligations regarding
          AML and KYC. Failure to provide
          proper information or offering misrepresentations when completing the Investor
          Passport will delay or prevent the Company from approving the User and could
          result in the revocation of a prior
          approval.</span></p>

      <p class=MsoBodyText
         style='margin-top:.15pt'>&nbsp;</p>

      <p class=MsoListParagraph
         align=left
         style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:41.95pt;margin-bottom:.0001pt;text-align:left;
text-indent:-17.95pt'><strong><span>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span></strong><strong><span>Trading on The Platform by Approved <span>User</span></span></strong>
      </p>

      <p class=MsoListParagraph
         align=left
         style='margin-top:10.2pt;margin-right:
0cm;margin-bottom:0cm;margin-left:77.2pt;margin-bottom:.0001pt;text-align:left;
text-indent:-17.95pt'><strong><span>a.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span></strong><strong><span>Secondary Trading Process <span>–</span></span></strong></p>

      <p class=MsoListParagraph
         style='margin-top:10.2pt;margin-right:5.85pt;
margin-bottom:0cm;margin-left:113.95pt;margin-bottom:.0001pt'><span style='font-family:"Trebuchet MS",sans-serif'>▪<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><u><span
                style='position:relative;top:-.5pt'>Selling</span></u><span style='position:relative;top:-.5pt'> - The
          User, when acting as
          a <strong>Seller/Offeror</strong>, may create an <strong>Offer/Sell order, </strong></span><span>which
          shall indicate the Security, number of Shares,
          duration of order Term and an Ask Price that will cause the Security to be
          offered on the Platform. By entering an Offer, the User is generating
          instructions to transfer the security to a buyer in the event of a match. The
          Term of the Offer is good ‘til canceled if no period of time is chosen by
          Seller. The User can cancel the Offer
          at any time prior to a match. If a
          match does not occur during the term, the Seller may re-Offer the Security for
          another Term.</span></p>

      <p class=MsoListParagraph
         style='margin-top:10.25pt;margin-right:6.0pt;
margin-bottom:0cm;margin-left:114.0pt;margin-bottom:.0001pt;'><span style='font-family:"Trebuchet MS",sans-serif'>▪<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><u><span
                style='position:relative;top:-.5pt'>Buying</span></u><span style='position:relative;top:-.5pt'> - The
          User, when acting as a <strong>Buyer/Bidder</strong>, may place a <strong>Bid/Buy order</strong>,
          which </span><span>shall indicate the
          Security, number of shares and duration of the Bid. The Term of the Bid
          is good ‘til canceled if no period of time is chosen by Buyer.</span></p>

    </div>

    <span style='font-family:"Arial",sans-serif'><br clear=all
          style='page-break-before:always'>
    </span>

    <div class=WordSection2>

      <p class=MsoListParagraph
         style='margin-top:3.35pt'><span>b.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><strong><span>Match
            Process </span></strong><span>-
          During the Term, Buyers may place Bids on the Platform to purchase the Security. The Seller is obligated to
          sell and the Buyer is obligated to buy the
          Security per the terms of this Agreement if the Buyer’s Bid price is at or above the Seller’s Offer Price
          during the Term. The
          Platform allows for partial fills of
          any Bid or Offer entered by the User. The
          Company reserves the sole right to cancel any open Bid or Offer of Shares of
          the Security at any time and all parties agree to hold the Company harmless if
          such is the case.</span></p>

      <p class=MsoBodyText
         style='margin-top:1.55pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>c.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><strong><span>Match
            Price </span></strong><span>– At Platform market open, the
          Match Price
          is the average of the Bid/Offer Price of a Bid/Offer order resting on the
          Platform’s order book and an Offer/Bid with an Offer/Bid Price at or below/at
          or above the former order resting on the Platform’s order book. During Platform market hours immediately
          following market open, the Match Price is the Bid/Offer Price of a Bid/Offer
          order resting on the Platform’s order book, when a subsequent Offer/Bid with an
          Offer/Bid Price at or below/at or above the resting order is entered onto the Platform’s order book. The total
          amount due from the Buyer is equal to the Match Price, plus any commission and
          fees. The amount due the Seller is
          equal to the Match Price, less any commission and fees. The Company may, at its
          sole discretion, reduce the commission paid by the Buyer or Seller.</span></p>

      <p class=MsoBodyText
         style='margin-top:1.7pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-top:.05pt'><span>d.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><strong><span>Offer Price </span></strong><span>-
          The Seller must indicate an Offer Price. If, at any time during the Seller’s
          Offer order Term, the Offer is the highest-priced Offer on the order book and a
          User places a Bid order at or above the Offer Price, the Offer order will be
          considered matched and the Security will be transferred from the Offeror to the
          matching Bidder.</span></p>

      <p class=MsoListParagraph
         style='margin-top:10.2pt;margin-right:6.05pt;
margin-bottom:0cm;margin-left:78.0pt;margin-bottom:.0001pt'><span>e.<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><strong><span>Bid Price - </span></strong><span>The
          User must indicate a Bid Price when placing a Bid order. If, at any time during the Bid order
          Term, the Bid is the
          highest-priced Bid on the order book and a User places an Offer order at or
          below the Bid Price, the Bid order will be considered matched and the Security
          will be transferred from the Offeror to the matching Bidder.</span></p>

      <p class=MsoBodyText
         style='margin-top:.05pt'>&nbsp;</p>

      <p class=MsoListParagraph
         align=left
         style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:77.2pt;margin-bottom:.0001pt;text-align:left;
text-indent:-17.95pt'><span>f.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><strong><span>Trading Time Zone </span></strong><span>- Eastern Standard or Daylight Time.
          <span>24/7/365.</span></span></p>

      <p class=MsoListParagraph
         style='margin-top:10.3pt'><span>g.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><strong><span>Document
            Delivery - </span></strong><span>User agrees to execute and deliver promptly to the Company any and all
          agreements, documents or instruments necessary or appropriate, for the
          avoidance of doubt, to effect an assignment or substitution on the books and
          records, or substantial equivalent, by the Issuer of the Shares, as required by
          Company to fulfill the obligations of the User as described in this Agreement. Documents and data may be
          delivered electronically. Agreements
          are considered binding on the User if certified with electronic signatures or
          memorialized via an affirmative check <span>box.</span></span></p>

      <p class=MsoBodyText
         style='margin-top:1.15pt'>&nbsp;</p>

      <p class=MsoListParagraph
         align=left
         style='margin-top:0cm;margin-right:6.05pt;
margin-bottom:0cm;margin-left:42.0pt;margin-bottom:.0001pt;text-align:left'><strong><span>3.<span
                  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span></strong><strong><span>Representation and Warranties of the User – </span></strong><span>The
          User hereby
          represents, warrants, agrees and
          acknowledges the following:</span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>a.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>The User has the full right, power and authority to
          execute this Agreement along with any other documents or agreements as required
          by the Company to fulfil any obligations or grant powers in this Agreement.</span></p>

      <p class=MsoBodyText
         style='margin-top:1.1pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>b.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>Securities are
          offered through Andes Capital Group, LLC, a registered broker-dealer and member
          of FINRA/SIPC. Neither Andes Capital Group, nor any of its affiliates, shall be
          deemed to be providing any investment advice or making any investment
          recommendations to any person.</span></p>

      <p class=MsoBodyText
         style='margin-top:.45pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>c.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>Assets
          listed on the Platform are securities that are
          not publicly traded, may be subject to holding period requirements and are
          intended for qualified investors with no need for liquidity in such <span>investment.</span></span></p>

      <p class=MsoBodyText
         style='margin-top:1.05pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-top:.05pt;'><span>d.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>Investments in the
          Securities listed on the Platform are NOT bank deposits (and thus NOT insured
          by the FDIC or by any other federal governmental agency), are NOT guaranteed by
          the Company and/or its affiliates and may lose some or all of their value.</span></p>

      <p class=MsoBodyText
         style='margin-top:.6pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>e.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>Neither the U.S.
          Securities and Exchange Commission nor any federal or state securities
          commission or regulatory authority has recommended or approved any investment
          or the accuracy or completeness of any of the information or materials provided
          by or through the website.</span></p>

    </div>

    <span style='font-family:"Arial",sans-serif'><br clear=all
          style='page-break-before:always'>
    </span>

    <div class=WordSection3>

      <p class=MsoListParagraph
         style='margin-top:3.35pt;margin-right:6.05pt;
margin-bottom:0cm;margin-left:77.25pt;margin-bottom:.0001pt'><span>f.<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>The User has access to all
          information regarding the Security deemed necessary by the User to make an
          informed investment decision.</span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-right:6.05pt'><span>g.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>The User is
          sophisticated, has knowledge and experience
          in financial and business matters and is capable of evaluating the merits and
          risks of an investment in the Security.</span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>h.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>The User understands that the purchase of the Security
          involves substantial risk; and, the User must be able to afford the loss of the
          User’s entire investment.</span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>i.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>The User has consulted with or has had the opportunity
          to consult with a qualified attorney, tax advisor, or accountant, and
          understands the income tax aspects of the User’s activity on the <span>Platform.</span></span></p>

      <p class=MsoBodyText
         style='margin-top:.9pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-top:.05pt'><span>j.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>The User has reviewed and accepts any restrictions
          contained in the shareholders' agreement or similar agreement, if any, upon
          taking ownership of the Security.</span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph
         align=left
         style='margin-top:0cm;margin-right:0cm;
margin-bottom:0cm;margin-left:77.2pt;margin-bottom:.0001pt;text-align:left;
text-indent:-17.95pt'><span>k.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>The User has not relied on Company nor any of its affiliates for investment, legal or tax
          <span>advice.</span></span></p>

      <p class=MsoBodyText
         style='margin-top:.7pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>l.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>The User has not relied upon any representation or
          warranty made by the Company or its affiliates with respect to the value or
          marketability of the Security. The
          User accepts sole responsibility for the decision to buy or sell Security at
          the determined price and that the Match Price of the Security may be above or
          below the net asset value or book value of the Security.</span></p>

      <p class=MsoBodyText
         style='margin-top:1.0pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>m.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
          </span></span><span>No
          commission, fee or other compensation is due to any
          broker, finder or other agent of the User in connection with this transaction
          except as otherwise stated in the confirmation and, in the event of any claim
          for any commission, finder's fee or other such compensation, User agrees that
          it shall be exclusively responsible therefor.</span></p>

      <p class=MsoBodyText
         style='margin-top:1.0pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>n.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>The User is purchasing the Security exclusively for the
          User’s own account and not with a view to, or sale in connection with, a
          distribution.</span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-right:6.05pt'><span>o.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>All historical
          pricing provided to the User by the
          Company is for informational purposes only and is not indicative of the User’s
          ability to obtain similar results.</span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-top:.05pt'><span>p.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>The Company did not solicit any transaction, bid, ask
          or other such activity of the User on the <span>Platform.</span></span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>q.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>Any and all of the information and documents provided
          by the User to the Company are true, correct
          and complete. Providing false documents and/or information to the Company is
          grounds for rejecting the Users access to the Platform or revoking access if
          previously granted.</span></p>

      <p class=MsoBodyText
         style='margin-top:.9pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>r.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>The
          Platform is operated on a “best efforts” basis and
          Bids and/or Offers may not be present for any
          Security listed on the Platform.</span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>s.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>The User
          is solely responsible for any and all activity
          that occurs on the Platform when the User account is used. If a User
          believes that the User did not
          authorize a particular transaction or that a transaction was incorrectly
          executed, the User must contact Andes Capital Group at once to report the same. All confirmations
          are considered accurate
          and complete unless the User contacts the Company within three (3) days.</span></p>

      <p class=MsoListParagraph><span>&nbsp;</span></p>

      <p class=MsoListParagraph><span>t.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>With respect to trades deemed matched on the Platform,
          the User authorizes Andes Capital Group and/or the Issuers of the Securities to
          instruct custodians with respect to the clearing and settlement, and to
          otherwise fulfill the obligations, of the trade. Such Issuer, custodians and
          the Platform operator shall be entitled to rely upon, and are third party
          beneficiaries to, this authorization.</span></p>

      <p class=MsoListParagraph><span>&nbsp;</span></p>

      <p class=MsoNormal><span>&nbsp;</span></p>

      <p class=MsoListParagraph
         align=left
         style='margin-top:0cm;margin-right:6.05pt;
margin-bottom:0cm;margin-left:42.0pt;margin-bottom:.0001pt;text-align:left'><strong><span>4.<span
                  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span></strong><strong><span>Scope of Services Provided by Andes Capital Group, LLC. –
          </span></strong><span>The User acknowledges and understands the
          <span>following:</span></span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-right:6.1pt'><span>a.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>All securities
          are offered through Andes Capital Group,
          LLC., a registered broker-dealer and member of <span>FINRA/SIPC</span></span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-top:.05pt;margin-right:6.05pt;
margin-bottom:0cm;margin-left:77.25pt;margin-bottom:.0001pt'><span>b.<span
                style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>Andes Capital Group is a broker-dealer
          acting as an agent, not as a principal, in connection with the sale of the
          Security.</span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>c.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>Andes
          Capital Group is requesting certain information
          from the User is to satisfy FINRA and SEC rules and regulations governing &quot;Know Your Customer&quot; and
          Anti-Money Laundering standards, along</span></p>

    </div>

    <span style='font-family:"Arial",sans-serif'><br clear=all
          style='page-break-before:always'>
    </span>

    <div class=WordSection4>

      <p class=MsoBodyText
         style='margin-top:3.35pt;margin-right:.55pt;margin-bottom:
0cm;margin-left:77.25pt;margin-bottom:.0001pt'>with provisions of the Bank
        Secrecy Act, the USA PATRIOT Act and other regulations. The User may be required to provide more
        information to allow Andes
        Capital Group to fulfill its legal obligations.</p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-right:6.05pt'><span>d.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>The User was
          not solicited by Andes Capital Group or
          any Company entity in connection with the sale of any Security.</span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>e.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>Andes Capital Group and its representatives may receive
          fees, commissions and/or other compensation as a result of the User’s trading
          activity.</span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>f.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>Neither Andes Capital Group nor any of its
          representatives has offered a value of the Security to be sold through Andes
          Capital Group.</span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-top:.05pt'><span>g.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>Neither Andes Capital Group nor any of its
          representatives has suggested that User may obtain a certain price for the Security.</span></p>

      <p class=MsoBodyText
         style='margin-top:1.5pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>h.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>Any order book services offered by Andes Capital Group
          are limited to the “best-effort” functions associated with matching
          User-entered Bids and Offers.</span></p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>i.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>While Andes Capital Group and its affiliates have
          performed certain due diligence on the Issuers of the Securities being offered
          on the Platform, Andes Capital Group and its affiliates are in no way
          responsible for the actions of the Issuer of the Security. Any due
          diligence performed by the Andes
          Capital Group or its affiliates is not intended to be viewed as a
          recommendation or basis for any activity by the User on the Platform.</span></p>

      <p class=MsoBodyText
         style='margin-top:1.1pt'>&nbsp;</p>

      <p class=MsoListParagraph><span>j.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>Andes Capital Group is not a fiduciary for the User and
          has not offered and is not offering investment advice to the User. The User has engaged in a relationship
          with Andes Capital Group for the exclusive purpose of trading on the Platform.</span></p>

      <p class=MsoBodyText
         style='margin-top:8.5pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-right:6.05pt'><span>k.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span></span><span>Andes Capital Group does not guarantee or otherwise have responsibility for settling the
          trades and does
          not, at any time, exercise any level of control over the digital asset securities
          being sold or the cash being used to make the purchase.</span></p>

      <p class=MsoBodyText
         style='margin-top:4.3pt'>&nbsp;</p>

      <p class=MsoBodyText
         style='margin-top:1.8pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-top:0cm;margin-right:6.05pt;margin-bottom:
0cm;margin-left:41.95pt;margin-bottom:.0001pt'><strong><span>5.<span
                  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span></strong><strong><span>Indemnification </span></strong><span>–
          The User will defend, indemnify and harmless Company and its affiliates from
          and against any and all claims, losses, damages, and liabilities, joint or several, or actions, including
          shareholder actions, in respect thereof related to or arising
          directly or indirectly out of its: (i) services contemplated hereunder; and
          (ii) breaches of representations, warranties and covenants and agreements set
          forth in this <span>Agreement.</span></span></p>

      <p class=MsoBodyText
         style='margin-top:1.1pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-top:0cm;margin-right:6.05pt;margin-bottom:
0cm;margin-left:42.0pt;margin-bottom:.0001pt'><strong><span>6.<span
                  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span></strong><strong><span>Rescission -
          </span></strong><span>Company
          shall have the right, in its absolute discretion and without prior notice to
          the User, to rescind, reject, cancel or refuse to display any order or
          transaction. In such event, the
          Company shall have no liability to the User.</span></p>

      <p class=MsoBodyText
         style='margin-top:.9pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-top:0cm;margin-right:6.05pt;margin-bottom:
0cm;margin-left:42.0pt;margin-bottom:.0001pt'><strong><span>7.<span
                  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span></strong><strong><span>Account
            Suspension, or Termination - </span></strong><span>The
          Company, at its sole discretion and without notice,
          may terminate or suspend an approved User’s access to the Platform. In that case, the User will no longer have
          access to content on the Platform such as trade history, bids, offers and User
          Information.</span></p>

      <p class=MsoBodyText
         style='margin-top:4.75pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-top:.05pt;margin-right:6.05pt;
margin-bottom:0cm;margin-left:41.95pt;margin-bottom:.0001pt;'><strong><span>8.<span
                  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span></strong><strong><span>Claw back -
          </span></strong><span style='color:#151B26'>Company
          shall have the right to initiate a
          “claw back” of any Security after the trade has settled, to correct for any technological or
          market irregularity
          resulting in an erroneous transaction. User
          acknowledges that this may result in funds and Securities being reconciled,
          removed and credited, as required, to unwind the trade.</span></p>

      <p class=MsoListParagraph
         style='margin-top:10.25pt;margin-right:6.0pt;
margin-bottom:0cm;margin-left:42.0pt;margin-bottom:.0001pt'><strong><span>9.<span
                  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
            </span></span></strong><strong><span>Conflicts of Interest - </span></strong><span>Company may participate
          and receive compensation and
          fees from trades in which it is an agent for both a Buyer and a Seller. The User acknowledges and accepts this
          conflict of interest and waives any and all claims otherwise resulting from it.</span></p>

      <p class=MsoBodyText
         style='margin-top:.9pt'>&nbsp;</p>

      <p class=MsoListParagraph
         style='margin-top:0cm;margin-right:6.05pt;margin-bottom:
0cm;margin-left:41.95pt;margin-bottom:.0001pt'><strong><span>10.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
            </span></span></strong><strong><span>Entire Agreement
          </span></strong><span>- This Agreement constitutes the entire agreement between the User and
          the Company regarding the subject matter hereof. This Agreement shall supersede all prior or
          contemporaneous
          written and oral agreements, communications and other understanding relating to
          the subject matter hereof this <span>Agreement.</span></span></p>

    </div>

    <span style='font-family:"Arial",sans-serif'><br clear=all
          style='page-break-before:always'>
    </span>

    <div class=WordSection5>

      <p class=MsoListParagraph
         style='margin-top:4.1pt;margin-right:6.0pt;
margin-bottom:0cm;margin-left:42.0pt;margin-bottom:.0001pt'><strong><span>11.<span
                  style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
            </span></span></strong><strong><span>Dispute Resolution </span></strong><span>- Any dispute, claim or
          controversy which may
          arise out of this Agreement which cannot be amicably settled between the parties shall be finally settled
          by binding FINRA arbitration. By
          accepting this Agreement, the User agrees as follows:</span></p>

      <p class=MsoBodyText
         style='margin-top:.65pt'>&nbsp;</p>

      <p class=MsoNormal
         style='margin-top:0cm;margin-right:6.05pt;margin-bottom:
0cm;margin-left:77.95pt;margin-bottom:.0001pt;text-align:justify;text-indent:
-39.65pt;'><strong><span>(A) ALL PARTIES TO THIS AGREEMENT ARE GIVING UP THE RIGHT
            TO SUE EACH OTHER IN COURT,
            <span>INCLUDING</span> <span>THE</span> <span>RIGHT</span> <span>TO</span> <span>A</span> <span>TRIAL</span>
            <span>BY</span> <span>JURY,</span> <span>EXCEPT</span> <span>AS</span> <span>PROVIDED</span> <span>BY</span>
            <span>THE</span> <span>RULES</span> <span>OF</span> <span>THE</span></span></strong></p>

      <p class=MsoNormal
         style='margin-top:0cm;margin-right:6.0pt;margin-bottom:0cm;
margin-left:78.0pt;margin-bottom:.0001pt;text-align:justify;text-indent:-.05pt'><strong><span>ARBITRATION FORUM IN WHICH
            A
            CLAIM IS FILED; (B) Arbitration awards are generally final and binding; a party’s ability to
            have a court reverse or modify an arbitration award is very limited; (C) The
            ability of the parties to obtain documents, witness statements and other
            discovery is generally more limited in arbitration than in court proceedings;
            (D) The arbitrators do not have to explain the reason(s) for their award
            unless, in an eligible case, a joint request for an explained decision has been submitted by all parties to
            the panel at least 20
            days prior to the first scheduled
            hearing date; (E) The panel of arbitrators will typically include a minority of
            arbitrators who were or are affiliated with the securities industry; (F) The
            rules of some arbitration forums may impose time limits for bringing a claim in
            arbitration. In some cases, a claim that is ineligible for arbitration may be brought in
            <span>court;</span></span></strong></p>

      <p class=MsoNormal
         style='margin-top:0cm;margin-right:6.0pt;margin-bottom:0cm;
margin-left:78.0pt;margin-bottom:.0001pt;text-align:justify'><strong><span>(G) The rules of the
            arbitration forum in which the
            claim is filed, and any amendments thereto, shall be incorporated into this
            agreement; (H) the Parties agree that all controversies that may arise among
            the User and Andes Capital Group, LLC, a registered broker- dealer and member
            of FINRA/SIPC, their respective affiliates, and their respective officers,
            directors, employees, agents or representatives concerning any transaction or
            the construction, performance, or breach of this or any other agreement between
            the parties pertaining to securities and other property, whether entered into
            prior, on or subsequent to the date hereof, shall be determined by arbitration. The award of the
            arbitrators, or the
            majority of them, shall be final, and judgment upon the award rendered may be
            entered in any court, state or federal, having jurisdiction.</span></strong></p>

      <p class=MsoBodyText
         style='margin-top:.6pt'><strong>&nbsp;</strong></p>

      <p class=MsoBodyText
         style='margin-top:0cm;margin-right:5.9pt;margin-bottom:
0cm;margin-left:42.45pt;margin-bottom:.0001pt;text-align:justify;text-indent:
-18.5pt'>14. <strong>Validity </strong>- In case any term of this Agreement will be held invalid, illegal or
        unenforceable, in
        whole or in part, the validity of any of the other terms of this<span>
        </span>Agreement will not in any way be affected
        thereby.</p>

      <p class=MsoBodyText
         style='margin-top:.8pt'>&nbsp;</p>

      <p class=MsoNormal
         style='margin-top:.05pt;margin-right:0cm;margin-bottom:0cm;
margin-left:6.0pt;margin-bottom:.0001pt'><strong><span>This
            Agreement and all other referenced terms and agreements shall inure to the
            benefit of and be binding upon the
            respective heirs, legal representatives, successors or assigns of the parties.</span></strong></p>

      <p class=MsoBodyText><strong>&nbsp;</strong></p>

      <p class=MsoBodyText
         style='margin-top:9.05pt'><strong>&nbsp;</strong></p>

    </div>

  </div>
</app-page>
